import {Card, Container, Row, Col} from 'react-bootstrap';

import img1 from './sliderimages/1.jpg';
import img2 from './sliderimages/2.jpg';
import img3 from './sliderimages/3.jpg'

export default function PainCards() {
	return (
	<>
	<div style={{margin: '0 auto'}} >
	<br />
	<Container className='fluid'> 
	 <Row>
	  <Col className='d-flex justify-content-center'>
		    <Card style={{ width: '18rem' }}>
      <Card.Img variant="top" src={img1} />
      <Card.Body style={{backgroundColor: '#d1cc96', color: 'white'}}>
        <Card.Title>Foot / Leg / Ankle / Nerve</Card.Title>
        <Card.Text>
			SeniorSpray helps manage pain with a fragrant aroma.
			<br />
			<br />
			<br />
        </Card.Text>
      </Card.Body>
    </Card>
	</Col>
	<Col className='d-flex justify-content-center'>
		    <Card style={{ width: '18rem' }}>
      <Card.Img variant="top" src={img2} />
      <Card.Body style={{backgroundColor: '#a289ce', color: 'white'}}>
        <Card.Title>Neck / Shoulder / Arm / Hand</Card.Title>
        <Card.Text>
			Works quickly, you will feel a light warm or cold feel as it work it's way  into sore muscles.
        </Card.Text>
      </Card.Body>
    </Card>
	</Col>
	<Col className='d-flex justify-content-center'>
		    <Card style={{ width: '18rem' }}>
      <Card.Img variant="top" src={img3} />
      <Card.Body style={{backgroundColor: '#8ebc84', color: 'white'}}>
        <Card.Title>Back / Hip / Knee / Sciatica</Card.Title>
        <Card.Text>
			Eases shoulder, elbow and joint pain.
			<br />
			<br />
			<br />
			<br />
        </Card.Text>
      </Card.Body>
    </Card>
	</Col>
	</Row>
	
	</Container>
	</div>
	</>
	);
}
